import React, { useEffect, useState } from "react";
import moment from "moment";
import ModalComponent from "../../../components/modals/ModalComponent";
import SkeletonTable from "../../../components/table/SkeletonTable";
import columns from "../../../columns/reports/auditReport";
import { GetAuditReportApi } from "../../../api/request/report";

const AuditModal = ({ file, isOpen, setIsOpen }) => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const getAuditReportData = async () => {
    setIsLoading(true);
    try {
      const { data } = await GetAuditReportApi({ file_id: file?.id });
      if (data?.status) {
        setData(
          data?.data?.map((item) => {
            return {
              ...item,
              taskName: item?.task?.name,
              employeeName: item?.assigned_employee?.name,
              status: (
                <p
                  className={`font-bold uppercase ${
                    item?.status === "complete"
                      ? "text-green-500"
                      : "text-gray-500"
                  }`}
                >
                  {item?.status}
                </p>
              ),
              startDate: item?.start_date
                ? moment(item?.start_date).format("lll")
                : "",
              completedDate: item?.end_date
                ? moment(item?.end_date).format("lll")
                : "",
            };
          })
        );
      }
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (file?.id) getAuditReportData();
  }, [file]);

  return (
    <ModalComponent
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title={`Audit Report (${file?.service_name_slug})`}
      width={1000}
    >
      <SkeletonTable columns={columns} data={data} isLoading={isLoading} />
    </ModalComponent>
  );
};

export default AuditModal;
